export const flexWrapClasses = {
    wrap: 'flex-wrap',
    nowrap: 'flex-nowrap',
    reverse: 'flex-wrap-reverse',
};
